import { Skeleton } from "../../../components/dashboard/Skeleton";
import styles from "./HeroSkeleton.module.css";

// Mirrors the InstanceHero layout (identity bar + 3-cell KPI strip) so the
// page doesn't reflow when real data lands on a cold first load.
export const HeroSkeleton = (): JSX.Element => (
  <section className={styles.shell} aria-busy="true" aria-label="Loading your instances">
    <div className={styles.content}>
      <div className={styles.identity}>
        <Skeleton width="9rem" height="0.8rem" />
        <Skeleton width="14rem" height="2.4rem" radius="6px" />
      </div>
      <div className={styles.strip}>
        {[0, 1, 2].map((i) => (
          <div key={i} className={styles.cell}>
            <Skeleton width="5.5rem" height="0.7rem" />
            <Skeleton width="70%" height="1.1rem" />
          </div>
        ))}
      </div>
    </div>
  </section>
);
